import { ReactElement } from "react";

import { LinkButton, Picture, useAnalytics } from "../../components";
import { UiIntegrationModel } from "../../models";

import {
    Integration,
    LogoTitle,
    Content,
    Description,
    ButtonWrapper,
    FeaturedImage
} from "./UiIntegration.styles";

export type UiIntegrationProps = {
    readonly model: UiIntegrationModel;
    readonly featured?: boolean;
};

const UiIntegration = ({
    model: {
        id,
        content: {
            entryTitle,
            title,
            description,
            featuredImage,
            logo,
            buttonUrl,
            buttonText
        }
    },
    featured,
    ...rest
}: UiIntegrationProps): ReactElement => {
    const { sendTrackEvent } = useAnalytics();
    const titleId = `integration_title_${id}`;
    const buttonId = `integration_btn_${id}`;

    return (
        <Integration {...rest}>
            {featured && <FeaturedImage url={featuredImage?.url} />}
            <Content>
                <LogoTitle>
                    <Picture image={logo} decorative={true} />
                    <h3 id={titleId}>{title}</h3>
                </LogoTitle>
                <Description>{description}</Description>
                <ButtonWrapper>
                    <LinkButton
                        url={buttonUrl}
                        id={buttonId}
                        appearance="Secondary"
                        aria-labelledby={buttonId + " " + titleId}
                        style="Outline"
                        onClick={() =>
                            sendTrackEvent("clickedIntegration", {
                                eventContainer: "UiIntegrationGrid",
                                event: "clicked",
                                eventComponent: "button",
                                label: buttonText,
                                labelEnglish: "Integration Button",
                                parentLabel: entryTitle,
                                uuid: id,
                                href: buttonUrl
                            })
                        }
                        data-uuid={id}
                        testId="integration-button"
                    >
                        {buttonText}
                    </LinkButton>
                </ButtonWrapper>
            </Content>
        </Integration>
    );
};

export default UiIntegration;
